import React from 'react';
import { ProtectedRoute, useAuth } from '../../context/AuthContext';
import LayoutCliente from '../cliente/LayoutCliente';
import LayoutStaff from '../staff/LayoutStaff';

// Il cliente ha la sua barra (in alto su desktop, a cinque icone in basso su mobile); admin e collaboratori la
// barra dello staff nel nuovo stile (Oggi · Clienti · Documenti · Agenzie · Agenda, ricerca ⌘K)
const LayoutPerRuolo = ({ children, nuovoStile }) => {
  const { userType } = useAuth();
  if (userType === 'cliente') return <LayoutCliente nuovoStile={nuovoStile}>{children}</LayoutCliente>;
  if (userType === 'admin' || userType === 'collaboratore') return <LayoutStaff nuovoStile={nuovoStile}>{children}</LayoutStaff>;
  return <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">{children}</main>;  // (ProtectedRoute manda al login chi non è entrato)
};

// Layout protetto con navigazione e contenitore principale
export const ProtectedLayout = ({ children, adminOnly = false, allowCollaboratore = false, nuovoStile = false }) => {
  return (
    <ProtectedRoute adminOnly={adminOnly} allowCollaboratore={allowCollaboratore}>
      <LayoutPerRuolo nuovoStile={nuovoStile}>{children}</LayoutPerRuolo>
    </ProtectedRoute>
  );
};
